// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-profile-style{width:46px;height:45px;border-radius:50%}.loggedin-user-name{text-align:center;margin:auto}", ""]);
// Exports
module.exports = exports;
